import myEntrepreneurship from '@/pages/entrepreneur/myEntrepreneurship/myEntrepreneurship.vue'
import myStartUp from '@/pages/entrepreneur/myEntrepreneurship/myStartUp.vue'
import myEntrepreneurialTeam from '@/pages/entrepreneur/myEntrepreneurship/myTeam.vue'
import myEntrepreneurialTeamAdd from '@/pages/entrepreneur/myEntrepreneurship/addEntrepreneur.vue'
import myWindow from '@/pages/entrepreneur/myEntrepreneurship/myWindow.vue'

import previewWindow from '@/pages/entrepreneur/myEntrepreneurship/previewWindow.vue'

import editProfileEntrepreneur from '@/pages/entrepreneur/myEntrepreneurship/editProfile.vue'

import Convocation from '@/pages/entrepreneur/convocation/Convocation.vue'
import myIdea from '@/pages/entrepreneur/convocation/myIdea.vue'
import showMyIdea from '@/pages/entrepreneur/convocation/showMyIdea.vue'
import showMyTeam from '@/pages/entrepreneur/convocation/showMyTeam.vue'
import myTeam from '@/pages/entrepreneur/convocation/myTeam.vue'

import editProfileConvocation from '@/pages/entrepreneur/convocation/editProfileConvocation.vue'
import addEntrepreneur from '@/pages/entrepreneur/convocation/addEntrepreneur.vue'

const entrepreneurRoutes = [
  //------------------------------------
  //---------- Convocatoria ------------
  //------------------------------------

  {
    path: '/convocation',
    name: 'convocation',
    component: Convocation,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [

        {
          text: 'Convocatoria'
        }
      ]
    }
  },
  {
    path: '/convocation/my-idea',
    name: 'my-idea',
    component: myIdea,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Convocatoria',
          to: { name: 'convocation' }
        },
        {
          text: 'Mi Idea'
        }
      ]
    }
  },
  {
    path: '/convocation/my-team',
    name: 'myTeam',
    component: myTeam,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Convocatoria',
          to: { name: 'convocation' }
        },
        {
          text: 'Mi Equipo'
        }
      ]
    }
  },
  {
    path: '/convocation/my-team/my-profile',
    name: 'editProfileConvocation',
    component: editProfileConvocation,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Convocatoria',
          to: { name: 'convocation' }
        },
        {
          text: 'Mi Equipo',
          to: { name: 'myTeam' }
        },
        {
          text: 'Mi perfíl'
        }
      ]
    }
  },
  {
    path: '/convocation/my-team/add-entrepreneur',
    name: 'addEntrepreneur',
    component: addEntrepreneur,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Convocatoria',
          to: { name: 'convocation' }
        },
        {
          text: 'Mi Equipo',
          to: { name: 'myTeam' }
        },
        {
          text: 'Nuevo integrante'
        }
      ]
    }
  },
  {
    path: '/convocation/show-my-idea',
    name: 'showMyIdea',
    component: showMyIdea,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Convocatoria',
          to: { name: 'convocation' }
        },
        {
          text: 'Mi Idea'
        }
      ]
    }
  },
  {
    path: '/convocation/show-my-team',
    name: 'showMyTeam',
    component: showMyTeam,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Convocatoria',
          to: { name: 'convocation' }
        },
        {
          text: 'Mi equipo'
        }
      ]
    }
  },
  
  //------------------------------------
  //---------- Emprendimiento ----------
  //------------------------------------

  {
    path: '/my-entrepreneurship',
    name: 'myEntrepreneurship',
    component: myEntrepreneurship,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Mi Emprendimiento'
        }
      ]
    }
  },
  {
    path: '/my-entrepreneurship/my-startup',
    name: 'myStartUp',
    component: myStartUp,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Mi Emprendimiento',
          to: { name: 'myEntrepreneurship' }
        },
        {
          text: 'Mi Formulario de Inscripción'
        }
      ]
    }
  },
  {
    path: '/my-entrepreneurship/my-team',
    name: 'myEntrepreneurialTeam',
    component: myEntrepreneurialTeam,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Mi Emprendimiento',
          to: { name: 'myEntrepreneurship' }
        },
        {
          text: 'Mi Equipo'
        }
      ]
    }
  },
  {
    path: '/my-entrepreneurship/my-team/add',
    name: 'myEntrepreneurialTeamAdd',
    component: myEntrepreneurialTeamAdd,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Mi Emprendimiento',
          to: { name: 'myEntrepreneurship' }
        },
        {
          text: 'Mi Equipo',
          to: { name: 'myEntrepreneurialTeam' }
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  {
    path: '/my-entrepreneurship/my-team/my-profile',
    name: 'editProfileEntrepreneur',
    component: editProfileEntrepreneur,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Mi Emprendimiento',
          to: { name: 'myEntrepreneurship' }
        },
        {
          text: 'Mi Equipo',
          to: { name: 'myEntrepreneurialTeam' }
        },
        {
          text: 'Mi Perfíl'
        }
      ]
    }
  },
  {
    path: '/my-entrepreneurship/my-window',
    name: 'myWindow',
    component: myWindow,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Mi Emprendimiento',
          to: { name: 'myEntrepreneurship' }
        },
        {
          text: 'Mi Stand'
        }
      ]
    }
  },
  {
    path: '/my-entrepreneurship/my-window/preview',
    name: 'previewWindow',
    component: previewWindow,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Mi Emprendimiento',
          to: { name: 'myEntrepreneurship' }
        },
        {
          text: 'Mi Stand',
          to: { name: 'myWindow' }
        },
        {
          text: 'Vista previa',
        }
      ]
    }
  }
  
]

export default entrepreneurRoutes